import type { LazyCortanaPickerPlugin } from 'owa-cortana-compose';
import type { LazyAugLoopPlugin } from 'owa-editor-augloop-plugin';
import type { LazyDictationPlugin } from 'owa-editor-dictation-plugin';
import type SpellcheckPlugin from 'owa-editor-proofing-plugin/lib/plugin/SpellcheckPlugin';
import type DockingPlugin from 'owa-editor-docking-plugin/lib/plugin/DockingPlugin';
import type { LazyEmojiPickerPlugin } from 'owa-editor-emoji-picker-plugin';
import type { LazyForgottenAttachmentsPlugin } from 'owa-editor-forgotten-attachments-plugin';
import type { LazyLinkPlugin } from 'owa-editor-link-plugin';
import type { LazyAtMentionsPickerPlugin } from 'owa-editor-mentions-picker-plugin';
import type { LazyTopicPickerPlugin } from 'owa-editor-topic-picker-plugin';
import type { LazyPasteOptionPlugin } from 'owa-editor-paste-option-plugin';
import type { LazyProofingPlugin } from 'owa-editor-proofing-plugin';
import type { ReferenceAttachmentPlugin } from 'owa-editor-reference-attachment-plugin';
import type RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import type { LazySmartSuggestionsPlugin } from 'owa-editor-smart-suggestions-plugin';
import type { LazySmartComposePlugin } from 'owa-editor-smartcompose-plugin';
import type { LazyTableEditPlugin } from 'owa-editor-table-edit-plugin';
import type InlineImagePlugin from 'owa-inline-image/lib/plugins/InlineImagePlugin';
import type { LazyInlineImagePlugin } from 'owa-editor-inlineimage-plugin';
import type { LazyInlineImageResizePlugin } from 'owa-inline-image-resize-plugin';
import type { LazyInlineImageCropPlugin } from 'owa-inline-image-crop-plugin';
import type { LazyLinkPreviewPlugin } from 'owa-link-preview-compose';
import type { LazyFluidPlugin } from 'owa-fluid-integrations';
import type { LazyRotateImagePlugin } from 'owa-editor-rotate-image-plugin';
import type { LazySonoraPlugin } from 'owa-editor-sonora-plugin';
import type { LazyMessageExtensionCardPlugin } from 'owa-message-extension-cards';

// Full list of editor plugins used by Mail and Calendar
// To exclude a plugin from Mail or Calendar, add to ExcludedPluginsForMail or ExcludedPluginsForCalendar

export const orderedEditorPlugins = {
    docking: <DockingPlugin>null,
    dictation: <LazyDictationPlugin>null,
    ribbon: <RibbonPlugin>null,
    spellcheckPlugin: <SpellcheckPlugin>null,
    inlineImage: <InlineImagePlugin>null,
    inlineImageV2: <LazyInlineImagePlugin>null,
    inlineImageResize: <LazyInlineImageResizePlugin>null,
    inlineImageCrop: <LazyInlineImageCropPlugin>null,
    tableEdit: <LazyTableEditPlugin>null,
    smartSuggestions: <LazySmartSuggestionsPlugin>null,
    linkPreview: <LazyLinkPreviewPlugin>null,
    pasteOption: <LazyPasteOptionPlugin>null,
    link: <LazyLinkPlugin>null,
    mentionsPicker: <LazyAtMentionsPickerPlugin>null,
    topicPicker: <LazyTopicPickerPlugin>null,
    cortanaCompose: <LazyCortanaPickerPlugin>null,
    emojiPicker: <LazyEmojiPickerPlugin>null,
    smartCompose: <LazySmartComposePlugin>null,
    fluid: <LazyFluidPlugin>null,
    proofing: <LazyProofingPlugin>null,
    augLoop: <LazyAugLoopPlugin>null,
    forgottenAttachments: <LazyForgottenAttachmentsPlugin>null,
    referenceAttachment: <ReferenceAttachmentPlugin>null,
    rotateImage: <LazyRotateImagePlugin>null,
    sonora: <LazySonoraPlugin>null,
    messageExtensionCard: <LazyMessageExtensionCardPlugin>null,
};

export type PluginKey = keyof typeof orderedEditorPlugins;

type IEditorPlugins = { [K in PluginKey]: typeof orderedEditorPlugins[K] };

export default IEditorPlugins;
